import { useEffect, useRef, useState } from "react";
import "react-phone-input-2/lib/style.css";
import { PaymentType } from "../../interfaces/enum/paymentType";
import Spinners from "../spinner/spinner";
import YandexPaySplit from "../yandexPay/split/yandexPaySplit";
import _ from "lodash";
import { ConfigServer } from "../../configs/config.server";
import { Card, Col, Row } from "react-bootstrap";
import { Position } from "../../interfaces/ordering/sale/position";
import { Device } from "../../infrastructure/Device";
import { FormikProps } from "formik";
import { OrderingForSaleProps } from "../main/detailsOrder.props";
import { usePay } from "../../hooks/usePay";
import { usePaySplit } from "../../hooks/usePaySplit";
import CustomerForm from "../customerForm";

interface IState {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  paymentInstallments: number;
  isLoading: boolean;
  paymentType: PaymentType;
}

const initialState: IState = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  paymentInstallments: 0,
  isLoading: false,
  paymentType: PaymentType.PayByCard
};

export const DetailsOrderSplit = (props: OrderingForSaleProps): JSX.Element => {
  const [state, setState] = useState<IState>(initialState);
  const formikRef = useRef<FormikProps<IState>>(null);

  const config = ConfigServer(props.hostName);

  const { pay, isLoading: payLoading } = usePay(props, config);
  const { paySplit, isLoading: paySplitLoading } = usePaySplit(props);

  const isLoading = state.isLoading || payLoading || paySplitLoading;

  useEffect(() => {
    if (props.orderingForSale?.customer) {
      const { firstName, lastName, email, phone } = props.orderingForSale.customer;

      const phoneResult = props.isVisiblePhone ? (phone === 0 ? '' : phone.toString()) : phone === 0 || phone === null ? '79161111111' : phone.toString();

      setState(prev => ({
        ...prev,
        firstName,
        lastName,
        email,
        phone: phoneResult,
      }));
    }
  }, [props.orderingForSale]);

  const handleSplitPayment = async () => {
    if (formikRef.current) {
      const isValid = await formikRef.current.validateForm().then(errors => Object.keys(errors).length === 0);

      if (isValid) {
        formikRef.current.submitForm();
      } else {
        console.log("Форма содержит ошибки:", formikRef.current.errors);
      }
    }
  };

  const handleSubmit = (values: IState) => {
    switch (state.paymentType) {
      case PaymentType.PayByCard:
        pay(values);
        break;
      case PaymentType.Split:
        paySplit(values);
        break;
      default:
        pay(values);
        break;
    }
  };

  return (
    <>
      <Spinners isActive={isLoading} />

      {props.orderingForSale && (
        <>
          <Device desktop>
            <>
              <Row>
                <Col md={12} lg={12} xl={12} xxl={12} className="order-info-block">
                  {props.orderingForSale.orderNumber ? (
                    <p className="bb" data-qa-locator="text-order-number">
                      Ваш заказ № {props.orderingForSale.orderNumber}:
                    </p>
                  ) : (
                    <p className="bb" data-qa-locator="text-order-number">
                      Ваш заказ:
                    </p>
                  )}
                  <div data-qa-locator="text-position-name-list">
                    {props.orderingForSale.positionList.map(
                      (position: Position, index: number) => {
                        return <p key={index}>{position.productName}</p>;
                      }
                    )}
                  </div>
                </Col>
              </Row>

              <div style={{ marginLeft: '1%', marginTop: '-2%' }}>
                {/*<p className="bb" style={{ fontSize: '19px' }}>
                  Контактные данные:
                </p>*/}
                <Card style={{ marginBottom: '5%' }}>
                  <Card.Body>
                    <CustomerForm initialValues={{ firstName: state.firstName, lastName: state.lastName, email: state.email, phone: state.phone }}
                      onSubmit={handleSubmit}
                      isDisabled={props.orderingForSale.orderingId ? true : false}
                      customerPhone={props.orderingForSale.customer.phone}
                      isVisiblePhone={props.isVisiblePhone}
                      ref={formikRef}>
                      <div className="card-footer confirm-btn-wrap" style={{ borderTopWidth: "0px", marginTop: "0px" }}>
                        <Row className="mb-3">
                          <Col md={6} lg={6} xl={6} xxl={6} style={{ fontSize: "20px" }} data-qa-locator="total-sum">
                            Всего к оплате: {props.orderingForSale.totalSum.toLocaleString("ru")}&nbsp;<i className="fa-solid fa-ruble-sign" />
                          </Col>
                          <Col md={6} lg={6} xl={6} xxl={6} className="text-end">
                            <Row style={{ marginBottom: '6%' }}>
                              <button
                                className="btn btn-danger me-2"
                                onClick={() => {
                                  setState((prevState) => ({
                                    ...prevState,
                                    paymentType: PaymentType.PayByCard,
                                  }));
                                }}
                                data-qa-locator="btn-pay-total-sum"
                                type="submit"
                                data-bs-toggle="button"
                                style={{ fontSize: "18px" }}
                              >
                                Оплатить {props.orderingForSale.totalSum.toLocaleString("ru")}&nbsp;
                                <i className="fa-solid fa-ruble-sign" style={{ fontSize: "16px" }} />
                              </button>
                            </Row>
                          </Col>
                        </Row>

                      </div>
                    </CustomerForm>
                  </Card.Body>
                </Card>

                <YandexPaySplit totalAmount={props.orderingForSale.totalSum}
                  paymentSplit={() => {
                    setState((prevState) => ({
                      ...prevState,
                      paymentType: PaymentType.Split
                    }));
                    handleSplitPayment();
                  }} />
              </div>
            </>
          </Device>

          <Device mobile>
            <>
              <Row>
                <Col xs={12} sm={12} md={12} className="order-info-block">
                  <p className="bb" style={{ marginBottom: "0px" }} data-qa-locator="text-order-number">
                    Ваш заказ № {props.orderingForSale.orderNumber}:
                  </p>

                  <div data-qa-locator="text-position-name-list">
                    {props.orderingForSale.positionList.map(
                      (position: Position, index: number) => {
                        return (
                          <p className="lh-sm" key={index} style={{ marginBottom: "0px" }} data-qa-locator="text-order-number">
                            {position.productName}
                          </p>
                        );
                      }
                    )}
                  </div>
                </Col>
              </Row>

              <div>
                <p className="bb" style={{ marginTop: '5%', marginBottom: '0px' }}>
                  Контактные данные:
                </p>
                <CustomerForm initialValues={{ firstName: state.firstName, lastName: state.lastName, email: state.email, phone: state.phone }}
                  onSubmit={handleSubmit}
                  ref={formikRef}
                  isDisabled={props.orderingForSale.orderingId ? true : false}
                  isVisiblePhone={props.isVisiblePhone}
                  customerPhone={props.orderingForSale.customer.phone}
                >
                  <Row className="mb-3">
                    <Col xs={12} sm={12} md={12} className="order-total" data-qa-locator="total-sum">
                      Всего к оплате:
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col xs={5} sm={5} md={5} className="order-total">
                      <span className="text-span-price" data-qa-locator="total-sum">
                        {props.orderingForSale.totalSum.toLocaleString("ru")}
                        &nbsp;<i className="fa-solid fa-ruble-sign"></i>
                      </span>
                      <Row className="mb-3 lh-1">
                        <Col xs={12} sm={12} md={12}>
                          <span className="pay-span">
                            оплата всей стоимости заказа
                          </span>
                        </Col>
                      </Row>
                    </Col>

                    <Col xs={7} sm={7} md={7}>
                      <button className="btn btn-danger" type="submit" data-qa-locator="btn-pay-total-sum" data-bs-toggle="button"
                        onClick={() => {
                          setState((prevState) => ({
                            ...prevState,
                            paymentType: PaymentType.PayByCard,
                          }));
                        }}
                      >
                        Оплатить{" "}
                        {props.orderingForSale.totalSum.toLocaleString("ru")}
                        &nbsp;<i className="fa-solid fa-ruble-sign"></i>
                      </button>
                    </Col>
                  </Row>
                </CustomerForm>

                <YandexPaySplit totalAmount={props.orderingForSale.totalSum}
                  paymentSplit={() => {
                    setState((prevState) => ({
                      ...prevState,
                      paymentType: PaymentType.Split
                    }));

                    handleSplitPayment();
                  }} />
              </div>
            </>
          </Device>
        </>
      )}
    </>
  );
};